<template>
  <SvoiInput v-bind="$attrs" />
</template>

<script lang="ts" setup>
  import { SvoiInput } from '@svoi-ui/components/input'
</script>
